import * as z from 'zod';

export const createTeamSchema = z.object({
  name: z.string()
    .min(3, { message: "Team name must be at least 3 characters" })
    .max(50, { message: "Team name must be no more than 50 characters" }),
  shifts_per_provider: z.number()
    .int()
    .min(1, { message: "Must have at least 1 shift per provider" })
    .max(30, { message: "Cannot exceed 30 shifts per provider" })
    .default(13),
  day_providers_required: z.number()
    .int()
    .min(1, { message: "Must have at least 1 provider for day shifts" })
    .max(20, { message: "Cannot exceed 20 providers for day shifts" })
    .default(2),
  night_providers_required: z.number()
    .int()
    .min(0, { message: "Must have 0 or more providers for night shifts" })
    .max(20, { message: "Cannot exceed 20 providers for night shifts" })
    .default(1),
  scheduling_period_days: z.number()
    .int()
    .min(7, { message: "Scheduling period must be at least 7 days" })
    .max(90, { message: "Scheduling period cannot exceed 90 days" })
    .default(28),
  max_consecutive_shifts: z.number()
    .int()
    .min(1, { message: "Max consecutive shifts must be at least 1" })
    .max(10, { message: "Max consecutive shifts cannot exceed 10" })
    .default(5),
  min_rest_hours: z.number()
    .int()
    .min(6, { message: "Minimum rest hours must be at least 6" })
    .max(48, { message: "Minimum rest hours cannot exceed 48" })
    .default(10)
});

// Team settings schema extends create team schema but makes all fields optional
export const teamSettingsSchema = createTeamSchema.partial();

// Scheduling rules schema contains only the scheduling-related fields
export const schedulingRulesSchema = z.object({
  scheduling_period_days: createTeamSchema.shape.scheduling_period_days,
  max_consecutive_shifts: createTeamSchema.shape.max_consecutive_shifts,
  min_rest_hours: createTeamSchema.shape.min_rest_hours
});

// Staffing requirements schema contains only the staffing-related fields
export const staffingRequirementsSchema = z.object({
  shifts_per_provider: createTeamSchema.shape.shifts_per_provider,
  day_providers_required: createTeamSchema.shape.day_providers_required,
  night_providers_required: createTeamSchema.shape.night_providers_required
});

export type CreateTeamFormValues = z.infer<typeof createTeamSchema>;
export type TeamSettingsFormValues = z.infer<typeof teamSettingsSchema>;
export type SchedulingRulesFormValues = z.infer<typeof schedulingRulesSchema>;
export type StaffingRequirementsFormValues = z.infer<typeof staffingRequirementsSchema>; 